import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { FAQS } from './salesData';
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section id="faq" className="bg-ivory py-14 sm:py-24" aria-labelledby="faq-title" data-id="element-126" data-mp="1gjbyhiw26703">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-127" data-mp="24969rw0qbni8">
        <div className="grid gap-9 lg:grid-cols-12 lg:gap-16" data-id="element-128" data-mp="249zmreqa798t">
          <div className="lg:col-span-4" data-id="element-129" data-mp="28b1dt8a1oezp">
            <SectionTag data-id="element-130" data-mp="28a03j60urwj1">Preguntas</SectionTag>
            <h2 id="faq-title" className="mt-4 font-display text-[1.85rem] leading-[1.07] text-charcoal sm:text-[2.4rem]" data-id="element-131" data-mp="1ujwksp16mkyc">
              Lo que se pregunta antes de comprar
            </h2>
            <p className="mt-4 font-sans text-[0.92rem] leading-relaxed text-charcoal/60" data-id="element-132" data-mp="2n7abw6i78maj">
              Es un producto digital de recetas y fundamentos de fabricación. Todo lo que necesitás
              saber antes de empezar con la primera cookie.
            </p>
          </div>

          <div className="lg:col-span-8" data-id="element-133" data-mp="10uqdws08xpf6">
            <ul className="space-y-3" data-id="element-134" data-mp="10rm3hcw6txg2">
              {FAQS.map((faq, index) => {
              const isOpen = open === index;
              return <li key={faq.question} className={`overflow-hidden rounded-4xl transition-colors duration-200 ease-out ${isOpen ? 'bg-white shadow-bakery-sm' : 'bg-bone hover:bg-white'}`} data-id="element-135" data-mp="19tc2p4wba0oe" data-mpi={index}>
                    <h3 data-id="element-136" data-mp="1xiwodvjunc1d">
                      <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex min-h-[66px] w-full items-center justify-between gap-5 px-5 py-4 text-left focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40 sm:px-7" data-id="element-137" data-mp="1xjfwylnm0o2q">
                        <span className="font-display text-[1rem] leading-snug text-charcoal sm:text-[1.15rem]" data-id="element-138" data-mp="237egxxi7rqeb">
                          {faq.question}
                        </span>
                        <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-colors duration-200 ease-out ${isOpen ? 'bg-gold' : 'bg-gold-pale'}`} aria-hidden data-id="element-139" data-mp="2c8mh6l4aj1b1">
                          <PlusIcon className={`h-4 w-4 transition-transform duration-200 ease-out ${isOpen ? 'rotate-45 text-white' : 'text-gold-deep'}`} data-id="element-140" data-mp="2qz3ebs9w7524" />
                        </span>
                      </button>
                    </h3>
                    <AnimatePresence initial={false} data-id="element-141" data-mp="ta6mxdrvjc10">
                      {isOpen && <motion.div id={`faq-panel-${index}`} initial={{
                    height: 0,
                    opacity: 0
                  }} animate={{
                    height: 'auto',
                    opacity: 1
                  }} exit={{
                    height: 0,
                    opacity: 0
                  }} transition={{
                    duration: 0.22,
                    ease: [0.23, 1, 0.32, 1]
                  }} className="overflow-hidden" data-id="element-142" data-mp="ob3fxnsc2vqe">
                          <p className="max-w-2xl px-5 pb-6 pr-10 font-sans text-[0.9rem] leading-relaxed text-charcoal/65 sm:px-7" data-id="element-143" data-mp="1805gt4cec1ao">
                            {faq.answer}
                          </p>
                        </motion.div>}
                    </AnimatePresence>
                  </li>;
            })}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}